import { render, staticRenderFns } from "./groubZlv.vue?vue&type=template&id=44c20702&scoped=true&"
import script from "./groubZlv.vue?vue&type=script&lang=js&"
export * from "./groubZlv.vue?vue&type=script&lang=js&"
import style0 from "./groubZlv.vue?vue&type=style&index=0&id=44c20702&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c20702",
  null
  
)

export default component.exports